import styled, { css } from 'styled-components';
import { isGlobetrotter } from '../../../utils/theming.js';

// @ts-nocheck
var Ksps = styled.ul.withConfig({
  displayName: "Kspsstyle__Ksps",
  componentId: "sc-17mmbtr-0"
})(["display:flex;flex-direction:column;justify-content:flex-end;align-content:flex-end;gap:var(--space-100);"]);
var Ksp = styled.li.withConfig({
  displayName: "Kspsstyle__Ksp",
  componentId: "sc-17mmbtr-1"
})(["display:flex;align-items:center;flex-direction:row;list-style-type:none;", " svg{margin-right:var(--space-200);}"], isGlobetrotter(css(["font:var(--font-body-s);color:var(--color-text-subtle);"])));

export { Ksp, Ksps };
//# sourceMappingURL=Ksps.style.js.map
